import React from 'react';
import video from '../m3dasset/friburgo.mp4';
import './bgmain.css';


function BackGroundMain() {
    return(
        <div className='tw'>
            <video className="bgvideo" src={video} autoPlay loop muted playsInline preload="auto" />
        </div>
    );
}

export default BackGroundMain;



